module.exports = __webpack_public_path__ + "img/header-weddingRingsWhitegold@2x.d3ba05a.webp";